export const services = [
  {
    id: "gartenpflege",
    icon: "ri-leaf-line",
    title: "Gartenpflege",
    intro: "Die regelmäßige Pflege hält Rasen, Hecken und Beete das ganze Jahr in Form.",
    image:
      "https://readdy.ai/api/search-image?query=Realistic%20maintained%20small%20private%20home%20garden%20with%20a%20naturally%20green%20lawn%2C%20colourful%20flower%20beds%20and%20a%20neatly%20trimmed%20hedge%20along%20the%20border%2C%20soft%20daylight%2C%20authentic%20everyday%20garden%20look%2C%20no%20mowing%20stripes%2C%20natural%20colours%2C%20documentary%20style%2C%20no%20people&width=800&height=600&seq=svc-lawn-2026-a1&orientation=landscape&nocache=true",
    items: [
      "Rasenmähen & Rasenpflege",
      "Heckenschnitt",
      "Beetpflege",
      "Unkrautbekämpfung",
      "Laubbeseitigung",
      "Mulchen",
    ],
  },
  {
    id: "baumpflege",
    icon: "ri-scissors-cut-line",
    title: "Baumpflege",
    intro: "Fachgerechter Schnitt für gesunde Bäume – und für Ihre Sicherheit.",
    image:
      "https://readdy.ai/api/search-image?query=Well%20maintained%20fruit%20tree%20with%20a%20clean%20pruned%20crown%20in%20an%20orchard%2C%20wooden%20ladder%20leaning%20against%20the%20trunk%2C%20soft%20morning%20light%2C%20realistic%20documentary%20photography%2C%20natural%20colors%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=svc-tree-2026-a2&orientation=landscape",
    items: [
      "Obstbaumschnitt",
      "Kronenpflege",
      "Totholzentfernung",
      "Baumfällung",
      "Wurzelstockentfernung",
    ],
  },
  {
    id: "neuanlage",
    icon: "ri-plant-line",
    title: "Neuanlage & Gestaltung",
    intro: "Vom kahlen Boden zum fertigen Garten – geplant und angelegt aus einer Hand.",
    image:
      "https://readdy.ai/api/search-image?query=Freshly%20laid%20green%20roll%20turf%20lawn%20next%20to%20flower%20beds%20and%20young%20shrubs%20in%20a%20modern%20garden%2C%20rich%20green%20colors%2C%20natural%20daylight%2C%20realistic%20photography%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=svc-new-2026-a3&orientation=landscape",
    items: [
      "Rollrasen",
      "Graseinsaat",
      "Pflanzung von Hecken & Gehölzen",
      "Beratung",
    ],
  },
  {
    id: "rodung",
    icon: "ri-recycle-line",
    title: "Rodung & Entsorgung",
    intro: "Wir schaffen Platz und nehmen das Grüngut direkt mit.",
    image:
      "https://readdy.ai/api/search-image?query=Cleared%20overgrown%20garden%20area%20with%20neatly%20stacked%20cut%20branches%20and%20freshly%20chipped%20green%20waste%2C%20soft%20daylight%2C%20realistic%20documentary%20photography%2C%20earth%20tones%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=svc-clear-2026-a4&orientation=landscape",
    items: [
      "Freischneiden",
      "Häckseln",
      "Grüngutentsorgung",
    ],
  },
  {
    id: "reinigung",
    icon: "ri-brush-2-line",
    title: "Reinigung",
    intro: "Saubere Flächen und gepflegte Details rund ums Haus.",
    image:
      "https://readdy.ai/api/search-image?query=Clean%20swept%20stone%20terrace%20and%20paved%20driveway%20in%20front%20of%20a%20private%20house%2C%20tidy%20surface%20free%20of%20dirt%20and%20leaves%2C%20soft%20natural%20daylight%2C%20realistic%20documentary%20photography%2C%20natural%20colours%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=svc-clean-2026-a5&orientation=landscape&nocache=true",
    items: [
      "Pflaster- & Steinreinigung",
      "Dachrinnen",
    ],
  },
  {
    id: "winterdienst",
    icon: "ri-snowy-line",
    title: "Winterdienst",
    intro: "Räumen und Streuen für sichere Wege – für Privat und Firmen.",
    image:
      "https://readdy.ai/api/search-image?query=Snow%20covered%20paved%20driveway%20partially%20cleared%20and%20swept%20with%20fine%20grit%2C%20winter%20garden%20with%20bare%20trees%2C%20cold%20morning%20light%2C%20realistic%20documentary%20photography%2C%20no%20people%2C%20no%20text&width=800&height=600&seq=svc-winter-2026-a6&orientation=landscape",
    items: [
      "Winterdienst für Privat",
      "Winterdienst für Firmen",
      "Zuverlässig & termingerecht",
    ],
  },
];

export const extraNote = {
  title: "Gartenpflege nach Eigentümerwechsel",
  text: "Sie übernehmen eine Immobilie oder bereiten den Verkauf vor? Wir bringen Garten und Außenanlagen schnell wieder in einen gepflegten Zustand – auf Wunsch kurzfristig und unkompliziert.",
  image:
    "https://readdy.ai/api/search-image?query=Well%20maintained%20detached%20house%20with%20a%20tidy%20front%20garden%2C%20trimmed%20hedge%20and%20green%20lawn%2C%20real%20estate%20exterior%20view%2C%20warm%20afternoon%20light%2C%20realistic%20photography%2C%20no%20people%2C%20no%20text&width=1200&height=800&seq=banner-estate-2026-b1&orientation=landscape",
  points: [
    "Aufwertung vor dem Immobilienverkauf",
    "Übernahme nach Eigentümerwechsel",
    "Kurzfristige Termine möglich",
  ],
};

export const commercial = {
  title: "Außenanlagenpflege für Gewerbe",
  intro: "Für Hausverwaltungen, Eigentümergemeinschaften, Büro- & Gewerbeparks, Einzelhandel und Praxen übernehmen wir die laufende Pflege Ihrer Außenanlagen – verlässlich, planbar und ohne dass Sie sich kümmern müssen.",
  targets: [
    { icon: "ri-building-2-line", label: "Hausverwaltungen" },
    { icon: "ri-home-office-line", label: "Eigentümergemeinschaften" },
    { icon: "ri-building-line", label: "Büro- & Gewerbeparks" },
    { icon: "ri-store-2-line", label: "Einzelhandel" },
    { icon: "ri-hospital-line", label: "Praxen" },
  ],
  promises: [
    { icon: "ri-user-star-line", title: "Feste Ansprechpartner", text: "Ein direkter Kontakt, der Ihre Objekte kennt – keine wechselnden Zuständigkeiten." },
    { icon: "ri-calendar-check-line", title: "Flexible Terminplanung", text: "Wir richten uns nach Ihren Objektzeiten und stimmen die Einsätze vorab ab." },
    { icon: "ri-team-line", title: "Langfristige Zusammenarbeit", text: "Planbare Pflegeintervalle statt Einzelaufträge – für dauerhaft gepflegte Anlagen." },
  ],
};

export const stats = [
  { id: "rating", value: 5, decimals: 1, suffix: "", label: "Google-Bewertung", sub: "★★★★★" },
  { id: "areas", value: 6, decimals: 0, suffix: "", label: "Leistungsbereiche", sub: "Garten bis Winter" },
  { id: "cities", value: 5, decimals: 0, suffix: "", label: "Einsatzgebiete", sub: "rund um Erlangen" },
];